import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/mediabook/mediabook/src/templates/Course.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Exercise = makeShortcode("Exercise");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Weather Report`}</h1>
    <p>{`Imagine you are creating a program to give advice about what activities to do based on the weather.
You now know how to use conditional statements to let your code respond differently for different
weather values `}<span parentName="p" {...{
        "role": "img",
        "aria-label": "sun"
      }}>{`☀️`}</span></p>
    <h2>{`Steps to Complete`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Create a variable `}<inlineCode parentName="p">{`weather`}</inlineCode>{` with the string value sunny`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Write a program using a conditional statement to suggest an activity based on the weather. Your
condtional statement should follow this logic:`}</p>
      </li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`if the weather is sunny then print "Let's go to the park!"
else if the weather is foggy print "Let's go see a movie."
else if the weather is rainy print "Let's read a book indoors."
else print "Cooking is good in any weather!"
`}</code></pre>
    <ol {...{
      "start": 3
    }}>
      <li parentName="ol">{`Try out each case of your if-elif-else statement by changing the value of `}<inlineCode parentName="li">{`weather`}</inlineCode>{`!`}</li>
    </ol>
    <Exercise contentSrc="@makeschool2/T5-WeatherReport" mdxType="Exercise" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      